export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGOUT_USER = 'LOGOUT_USER';


export const INVALID_KEYS_SUCCESS = "INVALID_KEYS_SUCCESS";
export const INVALID_KEYS_FAILURE = "INVALID_KEYS_FAILURE";
export const INVALID_KEYS_REQUEST = "INVALID_KEYS_REQUEST";

export const GET_INVALID_KEYS_COUNT_SUCCESS = "GET_INVALID_KEYS_COUNT_SUCCESS";
export const GET_INVALID_KEYS_COUNT_FAILURE = "GET_INVALID_KEYS_COUNT_FAILURE";
export const GET_INVALID_KEYS_COUNT_REQUEST = "GET_INVALID_KEYS_COUNT_REQUEST";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_FAILURE = "EDIT_USER_FAILURE";
export const DEL_USER = "DEL_USERS";
export const DEL_USER_FAILURE = "DEL_USER_FAILURE";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE";
export const GET_ROLES_REQUEST = "GET_ROLES_REQUEST";
export const GET_USERS_ORGANIZATIONS_REQUEST = "GET_USERS_ORGANIZATIONS_REQUEST";
export const GET_USERS_ORGANIZATIONS_FAILURE = "GET_USERS_ORGANIZATIONS_FAILURE";
export const GET_USERS_ORGANIZATIONS_SUCCESS = "GET_USERS_ORGANIZATIONS_SUCCESS";
export const GET_MACHINES_REQUEST = "GET_MACHINES_REQUEST";
export const GET_MACHINES_FAILURE = "GET_MACHINES_FAILURE";
export const GET_MACHINES_SUCCESS = "GET_MACHINES_SUCCESS";
export const GET_MACHINES_ORGANIZATIONS_REQUEST = "GET_MACHINES_ORGANIZATIONS_REQUEST";
export const GET_MACHINES_ORGANIZATIONS_FAILURE = "GET_MACHINES_ORGANIZATIONS_FAILURE";
export const GET_MACHINES_ORGANIZATIONS_SUCCESS = "GET_MACHINES_ORGANIZATIONS_SUCCESS";

export const GET_MACHINE_REQUEST = "GET_MACHINE_REQUEST";
export const GET_MACHINE_FAILURE = "GET_MACHINE_FAILURE";
export const GET_MACHINE_SUCCESS = "GET_MACHINE_SUCCESS";
export const GET_MACHINE_DAILY_SALES_REQUEST = "GET_MACHINE_DAILY_SALES_REQUEST";
export const GET_MACHINE_DAILY_SALES_FAILURE = "GET_MACHINE_DAILY_SALES_FAILURE";
export const GET_MACHINE_DAILY_SALES_SUCCESS = "GET_MACHINE_DAILY_SALES_SUCCESS";
export const CREATE_MACHINE = "CREATE_MACHINE";
export const CREATE_MACHINE_FAILURE = "CREATE_MACHINE_FAILURE";
export const EDIT_MACHINE = "EDIT_MACHINE";
export const EDIT_MACHINE_FAILURE = "EDIT_MACHINE_FAILURE";
export const DELETE_MACHINE = "DELETE_MACHINE";
export const DELETE_MACHINE_FAILURE = "DELETE_MACHINE_FAILURE";

export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ENCASHMENTS_REQUEST = "GET_ENCASHMENTS_REQUEST";
export const GET_ENCASHMENTS_FAILURE = "GET_ENCASHMENTS_FAILURE";
export const GET_ENCASHMENTS_SUCCESS = "GET_ENCASHMENTS_SUCCESS";
export const GET_ORDERS_MACHINES_REQUEST = "GET_ORDERS_MACHINES_REQUEST";
export const GET_ORDERS_MACHINES_FAILURE = "GET_ORDERS_MACHINES_FAILURE";
export const GET_ORDERS_MACHINES_SUCCESS = "GET_ORDERS_MACHINES_SUCCESS";
export const GET_KEYS_TRANSACTIONS_REQUEST = "GET_KEYS_TRANSACTIONS_REQUEST";
export const GET_KEYS_TRANSACTIONS_FAILURE = "GET_KEYS_TRANSACTIONS_FAILURE";
export const GET_KEYS_TRANSACTIONS_SUCCESS = "GET_KEYS_TRANSACTIONS_SUCCESS";

export const GET_KEYS_REQUEST = "GET_KEYS_REQUEST";
export const GET_KEYS_FAILURE = "GET_KEYS_FAILURE";
export const GET_KEYS_SUCCESS = "GET_KEYS_SUCCESS";
export const CREATE_KEY = "CREATE_KEY";
export const CREATE_KEY_FAILURE = "CREATE_KEY_FAILURE";
export const EDIT_KEY = "EDIT_KEY";
export const EDIT_KEY_FAILURE = "EDIT_KEY";
export const DELETE_KEY = "DELETE_KEY";
export const DELETE_KEY_FAILURE = "DELETE_KEY";
export const GET_KEY_TYPES_REQUEST = "GET_KEY_TYPES_REQUEST";
export const GET_KEY_TYPES_FAILURE = "GET_KEY_TYPES_FAILURE";
export const GET_KEY_TYPES_SUCCESS = "GET_KEY_TYPES_SUCCESS";
export const GET_KEY_REQUEST = "GET_KEY_REQUEST";
export const GET_KEY_FAILURE = "GET_KEY_FAILURE";
export const GET_KEY_SUCCESS = "GET_KEY_SUCCESS";
export const GET_KEY_TRANSACTION_REQUEST = "GET_KEY_TRANSACTION_REQUEST";
export const GET_KEY_TRANSACTION_FAILURE = "GET_KEY_TRANSACTION_FAILURE";
export const GET_KEY_TRANSACTION_SUCCESS = "GET_KEY_TRANSACTION_SUCCESS";

export const GET_STATISTICS_DAILY_SALES_REQUEST = "GET_STATISTICS_DAILY_SALES_REQUEST";
export const GET_STATISTICS_DAILY_SALES_FAILURE = "GET_STATISTICS_DAILY_SALES_FAILURE";
export const GET_STATISTICS_DAILY_SALES_SUCCESS = "GET_STATISTICS_DAILY_SALES_SUCCESS";
export const GET_STATISTICS_MONTH_SUM_SALES_REQUEST = "GET_STATISTICS_MONTH_SUM_SALES_REQUEST";
export const GET_STATISTICS_MONTH_SUM_SALES_FAILURE = "GET_STATISTICS_MONTH_SUM_SALES_FAILURE";
export const GET_STATISTICS_MONTH_SUM_SALES_SUCCESS = "GET_STATISTICS_MONTH_SUM_SALES_SUCCESS";
export const GET_STATISTICS_MONTH_AVERAGE_SALES_REQUEST = "GET_STATISTICS_MONTH_AVERAGE_SALES_REQUEST";
export const GET_STATISTICS_MONTH_AVERAGE_SALES_FAILURE = "GET_STATISTICS_MONTH_AVERAGE_SALES_FAILURE";
export const GET_STATISTICS_MONTH_AVERAGE_SALES_SUCCESS = "GET_STATISTICS_MONTH_AVERAGE_SALES_SUCCESS";
export const GET_STATISTICS_MACHINES_REQUEST = "GET_STATISTICS_MACHINES_REQUEST";
export const GET_STATISTICS_MACHINES_FAILURE = "GET_STATISTICS_MACHINES_FAILURE";
export const GET_STATISTICS_MACHINES_SUCCESS = "GET_STATISTICS_MACHINES_SUCCESS";
export const GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_REQUEST = "GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_REQUEST";
export const GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_FAILURE = "GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_REQUEST";
export const GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_SUCCESS = "GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_SUCCESS";
export const GET_STATISTICS_DAILY_SALES_COUNT_REQUEST = "GET_STATISTICS_DAILY_SALES_COUNT_REQUEST";
export const GET_STATISTICS_DAILY_SALES_COUNT_FAILURE = "GET_STATISTICS_DAILY_SALES_COUNT_FAILURE";
export const GET_STATISTICS_DAILY_SALES_COUNT_SUCCESS = "GET_STATISTICS_DAILY_SALES_COUNT_SUCCESS";

export const GET_ORGANIZATIONS_REQUEST = "GET_ORGANIZATIONS_REQUEST";
export const GET_ORGANIZATIONS_FAILURE = "GET_ORGANIZATIONS_FAILURE";
export const GET_ORGANIZATIONS_SUCCESS = "GET_ORGANIZATIONS_SUCCESS";
export const CREATE_ORGANIZATION_FAILURE = "CREATE_ORGANIZATION_FAILURE";
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const EDIT_ORGANIZATION_FAILURE = "EDIT_ORGANIZATION_FAILURE";
export const EDIT_ORGANIZATION = "EDIT_ORGANIZATION";
export const DELETE_ORGANIZATION_FAILURE = "DELETE_ORGANIZATION_FAILURE";
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";

export const GET_REPORTS_REQUEST = "GET_REPORTS_REQUEST";
export const GET_REPORTS_FAILURE = "GET_REPORTS_FAILURE";
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
export const GET_REPORTS_NOT_ACCEPTED_REQUEST = "GET_REPORTS_NOT_ACCEPTED_REQUEST";
export const GET_REPORTS_NOT_ACCEPTED_FAILURE = "GET_REPORTS_NOT_ACCEPTED_FAILURE";
export const GET_REPORTS_NOT_ACCEPTED_SUCCESS = "GET_REPORTS_NOT_ACCEPTED_SUCCESS";
export const GET_REPORTS_ACTIVE_REQUEST = "GET_REPORTS_ACTIVE_REQUEST";
export const GET_REPORTS_ACTIVE_FAILURE = "GET_REPORTS_ACTIVE_FAILURE";
export const GET_REPORTS_ACTIVE_SUCCESS = "GET_REPORTS_ACTIVE_SUCCESS";
export const GET_REPORT_REQUEST = "GET_REPORT_REQUEST";
export const GET_REPORT_FAILURE = "GET_REPORT_FAILURE";
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS";
export const GET_REPORTS_MACHINES_REQUEST = "GET_REPORTS_MACHINES_REQUEST";
export const GET_REPORTS_MACHINES_FAILURE = "GET_REPORTS_MACHINES_FAILURE";
export const GET_REPORTS_MACHINES_SUCCESS = "GET_REPORTS_MACHINES_SUCCESS";
export const GET_REPORTS_SUBJECTS_REQUEST = "GET_REPORTS_SUBJECTS_REQUEST";
export const GET_REPORTS_SUBJECTS_FAILURE = "GET_REPORTS_SUBJECTS_FAILURE";
export const GET_REPORTS_SUBJECTS_SUCCESS = "GET_REPORTS_SUBJECTS_SUCCESS";
export const GET_REPORT_NEXT_SUCCESS = "GET_REPORT_NEXT_SUCCESS";
export const GET_REPORT_NEXT_FAILURE = "GET_REPORT_NEXT_FAILURE";
export const EDIT_REPORT_FAILURE = "EDIT_REPORT_FAILURE";
export const EDIT_REPORT_SUCCESS = "EDIT_REPORT_SUCCESS";
export const DELETE_REPORT_SUCCESS = "DELETE_REPORT_SUCCESS";
export const DELETE_REPORT_FAILURE = "DELETE_REPORT_FAILURE";
export const GET_REPORTS_WORKS_REQUEST = "GET_REPORTS_WORKS_REQUEST";
export const GET_REPORTS_WORKS_FAILURE = "GET_REPORTS_WORKS_FAILURE";
export const GET_REPORTS_WORKS_SUCCESS = "GET_REPORTS_WORKS_SUCCESS";

export const GET_LOGS_REQUEST = "GET_LOGS_REQUEST";
export const GET_LOGS_FAILURE = "GET_LOGS_FAILURE";
export const GET_LOGS_SUCCESS = "GET_LOGS_SUCCESS";
export const GET_MACHINE_LOGS_REQUEST = "GET_MACHINE_LOGS_REQUEST";
export const GET_MACHINE_LOGS_FAILURE = "GET_MACHINE_LOGS_FAILURE";
export const GET_MACHINE_LOGS_SUCCESS = "GET_MACHINE_LOGS_SUCCESS";

export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";


// WEBPACK FOOTER //
// ./src/constants/index.js